export const SCHEMA_VERSION = 1;
// Sync transport capabilities are versioned independently from persisted entity
// schemas. Protocol v2 is the first version that understands retention watermarks,
// durable pull cursors, and replace snapshots.
export const SYNC_PROTOCOL_VERSION = 2;

export const SYNC = {
  PULL_DEFAULT_LIMIT: 500,
  PULL_MAX_LIMIT: 2000,
  OP_LOG_TTL_DAYS: 7,
  TOMBSTONE_TTL_DAYS: 30,
} as const;

export const PRIORITY = {
  NONE: 0,
  LOW: 1,
  MID: 2,
  HIGH: 3,
} as const;

export type PriorityValue = (typeof PRIORITY)[keyof typeof PRIORITY];

export const TASK_STATUS = {
  OPEN: 0,
  DONE: 1,
  CANCELLED: 2,
} as const;

export type TaskStatusValue = (typeof TASK_STATUS)[keyof typeof TASK_STATUS];

export const ENTITY_KINDS = [
  'user_profile',
  'project',
  'section',
  'task',
  'comment',
  'tag',
  'task_tag',
] as const;

export type EntityKind = (typeof ENTITY_KINDS)[number];
